import { render, staticRenderFns } from "./KommuneAutocomplete.vue?vue&type=template&id=2d17c2fa&"
import script from "./KommuneAutocomplete.vue?vue&type=script&lang=js&"
export * from "./KommuneAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports